/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';
import { StudioPerformanceDataType } from '../types/services';

export const fetchStudioFilterData = (params: {
  page?: 'gross_revenue_trends';
}): Promise<{
  list: {
    id: string;
    name: string;
  }[];
  start_date: string;
  end_date: string;
}> => {
  // @ts-ignore
  return http.get('/api/v1/globalpedia_pc/performance_overview/studio_arr', { params });
};

export const fetchStudioPerformanceData = (params: {
  select_id: string[];
  yoy: boolean;
  mom: boolean;
  order?: 'asc' | 'desc';
  order_metric?: string;
}): Promise<StudioPerformanceDataType> => {
  // @ts-ignore
  return http.post('/api/v1/globalpedia_pc/performance_overview/studio_monthly_performance', params);
};

export const studioPerformanceDownLoad = (params: {
  file_type: 1 | 2; // 1: csv 2: excal
  select_id: string[];
  yoy: boolean;
  mom: boolean;
  order?: 'asc' | 'desc';
  order_metric?: string;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/performance_overview/studio_monthly_performance/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

export const fetchProjectFilterData = (params: {
  page?: 'gross_revenue_trends' | 'live_title' | 'in_development';
}): Promise<{
  list: {
    id: string;
    name: string;
    projects: {
      id: string;
      name: string;
    }[];
  }[];
  start_date: string;
  end_date: string;
}> => {
  // @ts-ignore
  return http.get('/api/v1/globalpedia_pc/performance_overview/project_monthly_performance/project_arr', { params });
};

export const fetchProjectPerformanceData = (params: {
  select_id: string[];
  yoy: boolean;
  mom: boolean;
  order?: 'asc' | 'desc';
  order_metric?: string;
}): Promise<StudioPerformanceDataType> => {
  // @ts-ignore
  return http.post('/api/v1/globalpedia_pc/performance_overview/project_monthly_performance', params);
};

export const projectPerformanceDownLoad = (params: {
  file_type: 1 | 2; // 1: csv 2: excal
  select_id: string[];
  yoy: boolean;
  mom: boolean;
  order?: 'asc' | 'desc';
  order_metric?: string;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/performance_overview/project_monthly_performance/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};
